export default "__VITE_ASSET__CDHwFPDP__"